import React from 'react';
import { Link } from 'react-router-dom';
import NotificationCountdown from 'components/NotificationCountdown';
import DesktopNotification from '../DesktopNotification';
import DrawingIcon from './assets/Notifications_Drawing.svg';

export default function DrawingStartSoon({ drawingId, start, ...rest }) {
  const to = drawingId ? '/drawings/' + drawingId : '/drawings';
  return (
    <DesktopNotification
      className="notification-drawing-start-soon"
      title={
        <NotificationCountdown
          text={'Drawing begins in '}
          time={start}
          onClose={rest.onClose}
          notificationId={rest.notificationId}
        />
      }
      content={'A drawing is about to start. Join now to see who wins!'}
      iconSrc={DrawingIcon}
      footer={
        <Link
          className="btn btn-success notification-drawing-start-soon-button"
          to={to}
          onClick={e => {
            rest.onClose(rest.notificationId);
          }}
        >
          <span>Join</span>
        </Link>
      }
      {...rest}
    />
  );
}
